import { render, staticRenderFns } from "./HostAfricaServerLicenses.vue?vue&type=template&id=0aa950a1&"
import script from "./HostAfricaServerLicenses.vue?vue&type=script&lang=js&"
export * from "./HostAfricaServerLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports